import { TextField as MuiTextField } from '@mui/material';
import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '.';
import { FieldErrors } from './FieldErrors';

type NumberFieldProps = {
  label: React.ReactNode;
} & React.ComponentProps<typeof MuiTextField>;

export const NumberField = (props: NumberFieldProps) => {
  const field = useFieldContext<number>();
  const hasTriedToSubmit = useStore(
    field.form.store,
    (state) => state.submissionAttempts > 0
  );
  return (
    <MuiTextField
      type="number"
      value={Number.isNaN(field.state.value) ? '' : field.state.value}
      onChange={(e) =>
        field.handleChange(e.target.value ? parseInt(e.target.value, 10) : 0)
      }
      onBlur={field.handleBlur}
      error={
        field.state.meta.isTouched || hasTriedToSubmit
          ? field.state.meta.errors.length > 0
          : false
      }
      helperText={<FieldErrors meta={field.state.meta} />}
      fullWidth
      label={props.label}
    />
  );
};
